/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'handset-details-dialog',
  templateUrl: './handset-details-dialog.component.html',
  styleUrls: ['./handset-details-dialog.component.scss'],
})
export class HandsetDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<HandsetDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }
}
